import { Box, Flex } from '@mantine/core';
import colors from '../constants/AvatarsColors';

const Client = ({ email }) => {
  const initial = email.charAt(0);
  const color = colors[(initial.charCodeAt(0) - 65) % 19];

  return (
    <Flex className="client" mb="xs" align="center">
      <Box className="avatar-initials" style={{ backgroundColor: color, marginRight: '8px' }}>
        {initial}
      </Box>

      {email.split('@')[0]}
    </Flex>
  );
};

export default Client;
